import { convertDateToValue, convertGender } from 'helpers'
import moment from 'moment'
import { tinhTuoiThai } from 'pages/QuanLyKhamBenh/views/ThongTinKham/constantsTTK'
import { useSelector } from 'react-redux'
import i18n, { languageKeys } from "../../../../i18n"
import styles from "./styles.module.less"
import stylesAivi from "./stylesAivi.module.less"
import stylesGl from "./stylesGl.module.less"
import stylesIshi from "./stylesIshi.module.less"
import stylesNamAuHaThanh from "./stylesNamAuHaThanh.module.less"
import stylesThanhY from "./stylesThanhY.module.less"
import { CaretDownOutlined, CaretRightOutlined, PrinterOutlined } from '@ant-design/icons'
import { apiPhieuTra } from 'pages/RisNhapTay/TraKetQuaCdha/services'
import { notification } from 'antd'
import { useRef, useState } from 'react'
import { ModalPDF } from 'components'

const PhieuTraKetQua = ({ data, LICH_KHAM_ID, isShowContent = true, isShowNgayTraKetQua = false }) => {

    const userProfile = useSelector((state) => state.auth.user);
    const dataLocal = useSelector((state) => state.data);
    const [showContent, setShowContent] = useState(isShowContent)
    const pdfRef = useRef();
    

    const getClass = (key) => {
        let partner_code = userProfile?.partner_code
        partner_code = "isgisg123"

        switch (partner_code) {
            case 'skty': return stylesThanhY[key];
            case 'isgisg123': return stylesIshi[key];

            case '0018nadk':
            case '0018dk248':
            case '0018htdk':
                return stylesNamAuHaThanh[key];

            case 'aivi052428': return stylesAivi[key];
            case 'greenlabuh': return stylesGl[key];

            default: return styles[key];
        }
    };

    const handlePrint = async () => {
        let req = {
            partner_code: userProfile.partner_code,
            BENH_VIEN_ID: userProfile.BENH_VIEN_ID,
            PHIEU_ID: [data.CTP_ID],
            LICH_KHAM_ID: data?.LICH_KHAM_ID || LICH_KHAM_ID
          };
          let response = await apiPhieuTra(req);
          if (response) {
            let array = response.result;
            let data_print = array.map((item) => {
              return {
                ...item,
                maumota: item.MO_TA,
                ket_luan: item.KET_LUAN,
                arr_anh_ID: item.ANH_MO_TA,
              };
            });
            const template = dataLocal?.template_pdf?.PHIEU_TRA_KQ_RIS || "PhieuTraKq";
            if (!template) {
              notification.error({
                message: "Không có mẫu in!",
                placement: "bottomLeft",
              });
              return;
            }
            await pdfRef.current.openModalWithData(data_print, template);
          }

    }

    const renderInfoGroup = () => {

        if (userProfile.partner_code === 'isgisg123' || userProfile.partner_code === 'skty') {
            return <>
                <div className={getClass('info-group')}>
                    <div className={getClass('row-group_patient-info')}>
                        <div className={getClass('row-group-70')} >{i18n.t(languageKeys.ten_khach_hang)} : <span>{data.TEN || ""}</span></div>
                        <div className={getClass('row-group-30')} >
                            <span >{i18n.t(languageKeys.field_Ngay_sinh)}: </span>
                            <span>{data?.NGAY_SINH.length === 8 ? moment(data?.NGAY_SINH, 'YYYYMMDD').format('DD/MM/YYYY') : data?.NGAY_SINH}</span>
                        </div>
                    </div>
                    <div>
                        <span>{i18n.t(languageKeys.field_Chan_doan_lam_sang)} : </span> {data.CHAN_DOAN_LAM_SANG || ""}
                    </div>
                    <div>
                        <span>{i18n.t(languageKeys.field_Dich_vu_chi_dinh)} : </span> {data.KY_THUAT_CHI_DINH || ""}
                    </div>
                </div>
            </>
        }


        if (userProfile.partner_code === 'aivi052428') {
            return <><div className={getClass('info-group')}>
                <div className={getClass('row-group_patient-info')}>
                    <div className={getClass('row-group-2')} >{i18n.t(languageKeys.ten_khach_hang)} : <span>{data.TEN || ""}</span></div>
                    <div className={getClass('row-group-3')} >
                        <span >{i18n.t(languageKeys.field_Ngay_sinh)}: </span>
                        <span>{data?.NGAY_SINH.length === 8 ? moment(data?.NGAY_SINH, 'YYYYMMDD').format('DD/MM/YYYY') : data?.NGAY_SINH}</span>
                    </div>
                    <div className={getClass('row-group-3')} ><span >{i18n.t(languageKeys.field_Gioi_tinh)}: </span><span> {convertGender(data.GIOI_TINH)}</span></div>
                </div>
                <div className={getClass('row-group_patient-info')}>
                    <div className={getClass('row-group-2')}><span >{i18n.t(languageKeys.field_So_dien_thoai)}: </span> <span>{data.SO_DIEN_THOAI}</span></div>
                    <div className={getClass('row-group-2')}><span >{i18n.t(languageKeys.field_Doi_tuong)}: </span> <span>{data?.TEN_DOI_TUONG || ''}</span></div>
                </div>
                <div className={getClass('dia-chi')}>
                    <span>{i18n.t(languageKeys.field_Dia_chi)} : </span> {data.DIA_CHI_CHI_TIET || ""}
                </div>
                <div>
                    <span>{i18n.t(languageKeys.field_Dich_vu_chi_dinh)} : </span> {data.KY_THUAT_CHI_DINH || ""}
                </div>
            </div>
            </>
        }

        if (userProfile.partner_code == "0018htdk" || userProfile.partner_code == "0018nadk" || userProfile.partner_code == "0018dk248") {
            return <><div className={getClass('info-group')}>
                <div className={getClass('row-group_patient-info')}>
                    <div className={getClass('row-group-2')} >{i18n.t(languageKeys.ten_khach_hang)} : <span>{data.TEN || ""}</span></div>
                    <div className={getClass('row-group-3')} >
                        <span >{i18n.t(languageKeys.field_Ngay_sinh)}: </span>
                        <span>{data?.NGAY_SINH.length === 8 ? moment(data?.NGAY_SINH, 'YYYYMMDD').format('DD/MM/YYYY') : data?.NGAY_SINH}</span>
                    </div>
                    <div className={getClass('row-group-3')} ><span >{i18n.t(languageKeys.field_Gioi_tinh)}: </span><span> {convertGender(data.GIOI_TINH)}</span></div>
                </div>
                <div className={getClass('row-group_patient-info')}>
                    <div className={getClass('row-group-2')}><span >{i18n.t(languageKeys.field_So_dien_thoai)}: </span> <span>{data.SO_DIEN_THOAI}</span></div>
                    <div className={getClass('row-group-2')}><span >{i18n.t(languageKeys.field_Doi_tuong)}: </span> <span>{data?.TEN_DOI_TUONG || ''}</span></div>
                </div>
                <div>
                    <span>{i18n.t(languageKeys.dia_chi)} : </span> {data.DIA_CHI_CHI_TIET || ""}
                </div>
                <div>
                    <span>{i18n.t(languageKeys.field_Chan_doan_lam_sang)} : </span> {data.CHAN_DOAN_LAM_SANG || ""}
                </div>
                <div>
                    <span>{i18n.t(languageKeys.field_Dich_vu_chi_dinh)} : </span> {data.KY_THUAT_CHI_DINH || ""}
                </div>
            </div>
            </>
        }

        return <><div className={getClass('info-group')}>
            <div className={getClass('row-group_patient-info')}>
                <div className={getClass('row-group-2')} >{i18n.t(languageKeys.ten_khach_hang)} : <span>{data.TEN || ""}</span></div>
                <div className={getClass('row-group-3')} >
                    <span >{i18n.t(languageKeys.field_Ngay_sinh)}: </span>
                    <span>{data?.NGAY_SINH.length === 8 ? moment(data?.NGAY_SINH, 'YYYYMMDD').format('DD/MM/YYYY') : data?.NGAY_SINH}</span>
                </div>
                <div className={getClass('row-group-3')} ><span >{i18n.t(languageKeys.field_Gioi_tinh)}: </span><span> {convertGender(data.GIOI_TINH)}</span></div>
            </div>
            <div className={getClass('row-group_patient-info')}>
                <div className={getClass('row-group-2')}><span >{i18n.t(languageKeys.field_So_dien_thoai)}: </span> <span>{data.SO_DIEN_THOAI}</span></div>
                <div className={getClass('row-group-2')}><span >{i18n.t(languageKeys.field_Doi_tuong)}: </span> <span>{data?.TEN_DOI_TUONG || ''}</span></div>
            </div>
            <div>
                <span>{i18n.t(languageKeys.field_Chan_doan_lam_sang)} : </span> {data.CHAN_DOAN_LAM_SANG || ""}
            </div>
            <div>
                <span>{i18n.t(languageKeys.field_Dich_vu_chi_dinh)} : </span> {data.KY_THUAT_CHI_DINH || ""}
            </div>
        </div>
        </>
    }


    const renderBody = () => {

        if (userProfile.partner_code === 'isgisg123') {
            return <>
                <div>
                    <h2 style={{ lineHeight: '14px', margin: '10px 0px 0px 0px' }}>II.{(i18n.t(languageKeys.ky_thuat)).toUpperCase()}</h2>
                </div>
                <div dangerouslySetInnerHTML={{ __html: data?.KY_THUAT || " " }} className={getClass('maukythuat-content')} />
                <div>
                    <h2 style={{ lineHeight: '14px', margin: '10px 0px 5px 0px' }} className={getClass('title-mo-ta')}>
                        III.{(i18n.t(languageKeys.mo_ta)).toUpperCase()}
                    </h2>
                </div>
                <div dangerouslySetInnerHTML={{ __html: data.maumota?.replaceAll("&lt;image&gt;", "") }} className={getClass('maumota-content')} />
                <h2 className={getClass('title_kl')} id="title_kl" style={{ lineHeight: '14px', margin: '10px 0px 0px 0px' }}>
                    IV.{(i18n.t(languageKeys.ket_luan)).toUpperCase()}
                </h2>
                <div dangerouslySetInnerHTML={{ __html: data.ket_luan }} className={getClass('ket-luan-content')} />
                {
                    data.MA_LOAI_DV === 'LDV-SA-THAI' && !!data.LIST_DU_LIEU_SAN?.[0]
                        ? (
                            <div style={{ fontSize: 12 }}>
                                <p>{i18n.t(languageKeys.du_kien_sinh)}: {convertDateToValue(data.LIST_DU_LIEU_SAN[0].DU_KIEN_SINH)}</p>
                                <p>{i18n.t(languageKeys.tuoi_thai_hien_tai)}: {tinhTuoiThai(data.LIST_DU_LIEU_SAN[0].DU_KIEN_SINH)}</p>
                            </div>
                        )
                        : <></>
                }
            </>
        }

        if (userProfile.partner_code === 'aivi052428') {
            return <>
                <div>
                    <h2 style={{ lineHeight: '14px', margin: '10px 0px 5px 0px' }} className={getClass('title-mo-ta')}>
                        I.{(i18n.t(languageKeys.mo_ta)).toUpperCase()}
                    </h2>
                </div>
                <div dangerouslySetInnerHTML={{ __html: data.maumota?.replaceAll("&lt;image&gt;", "") }} className={getClass('maumota-content')} />
                <h2 className={getClass('title_kl')}   id="title_kl" style={{ lineHeight: '14px', margin: '10px 0px 0px 0px' }}>
                    II.{(i18n.t(languageKeys.ket_luan)).toUpperCase()}
                </h2>
                <div dangerouslySetInnerHTML={{ __html: data.ket_luan }} className={getClass('ket-luan-content')} />
                {
                    data.MA_LOAI_DV === 'LDV-SA-THAI' && !!data.LIST_DU_LIEU_SAN?.[0]
                        ? (
                            <div style={{ fontSize: 12 }}>
                                <p>{i18n.t(languageKeys.du_kien_sinh)}: {convertDateToValue(data.LIST_DU_LIEU_SAN[0].DU_KIEN_SINH)}</p>
                                <p>{i18n.t(languageKeys.tuoi_thai_hien_tai)}: {tinhTuoiThai(data.LIST_DU_LIEU_SAN[0].DU_KIEN_SINH)}</p>
                            </div>
                        )
                        : <></>
                }
            </>
        }

        return <>
            <div>
                <h2 style={{ lineHeight: '14px', margin: '10px 0px 5px 0px' }} className={getClass('title-mo-ta')}>
                    II.{(i18n.t(languageKeys.mo_ta)).toUpperCase()}
                </h2>
            </div>
            <div dangerouslySetInnerHTML={{ __html: data.maumota?.replaceAll("&lt;image&gt;", "") }} className={getClass('maumota-content')} />
            <h2 id="title_kl" className={getClass('title_kl')} style={{ lineHeight: '14px', margin: '10px 0px 0px 0px' }}>
                III.{(i18n.t(languageKeys.ket_luan)).toUpperCase()}
            </h2>
            <div dangerouslySetInnerHTML={{ __html: data.ket_luan }} className={getClass('ket-luan-content')} />
            {
                data.MA_LOAI_DV === 'LDV-SA-THAI' && !!data.LIST_DU_LIEU_SAN?.[0]
                    ? (
                        <div style={{ fontSize: 12 }}>
                            <p>{i18n.t(languageKeys.du_kien_sinh)}: {convertDateToValue(data.LIST_DU_LIEU_SAN[0].DU_KIEN_SINH)}</p>
                            <p>{i18n.t(languageKeys.tuoi_thai_hien_tai)}: {tinhTuoiThai(data.LIST_DU_LIEU_SAN[0].DU_KIEN_SINH)}</p>
                        </div>
                    )
                    : <></>
            }
        </>
    }

    if (!data) {
        return ""
    }

    return (
        <div style={{
            padding: 12,
            borderRadius: 15,
            backgroundColor:"#f5f6fa"
        }}>
            <p style={{
                display:"flex",
                marginBlock: 8,
                justifyContent:"space-between"
            }}>
                <p style={{color:"#2c3782", fontSize:16, fontWeight: 500, cursor:"pointer", display:"flex", gap: 10, alignItems:"center"}} onClick={()=>setShowContent(prev => !prev)}> {showContent ? <CaretDownOutlined/> : <CaretRightOutlined/>}  {data.TEN_DICHVU} { isShowNgayTraKetQua && data?.NGAY_TRA_KET_QUA ? `( ${moment(data?.NGAY_TRA_KET_QUA).format("DD/MM/YYYY")})` : ""}</p>
                {data?.TRANG_THAI_THUC_HIEN == 'DA_THUC_HIEN'? <p style={{cursor:"pointer", display:"flex", gap: 8, padding:"5.5px 24px", textAlign:"right", backgroundColor:"#6576ff", borderRadius: 8, color:"white"  }} onClick={handlePrint}><PrinterOutlined/>{i18n.t(languageKeys.field_In_phieu)}</p> :<p></p>}
            </p>
            <div style={{
                padding:12,
                borderRadius: 15,
                backgroundColor:"white",
                display: showContent ? "block" :"none"
            }} className={getClass('phieu-container')}>
                <div className={getClass('phieu-container-top')} id="phieu-container-top">
                    
                    <div className={getClass('title')}>{data.TEN_LOAI_PHIEU || ""} </div>
                    {
                        userProfile.partner_code === 'aivi052428'
                            ? ""
                            : <h2 className={getClass('tt-hc')} style={{ margin: '10px 0px 0px 0px' }}>
                                I.{(i18n.t(languageKeys.field_Thong_tin_hanh_chinh)).toUpperCase()}
                            </h2>
                    }
                    {renderInfoGroup()}
                </div>
                {renderBody()}

            </div>
            <ModalPDF ref={pdfRef} />
        </div>

    )
}

export default PhieuTraKetQua